import React from "react";
import InstitutionalPage from "../components/institutional/InstitutionalPage";
import { institutionalPages } from "../data/institutionalPages";

export default function Transparencia() {
  return <InstitutionalPage {...institutionalPages["/transparencia"]} />;
}
